import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration, Slider } from "@/shared-module/models";

@Component({
  selector: "app-slider-select",
  templateUrl: "sliderselect.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class SliderSelectComponent implements OnInit, OnDestroy {
  @Input() data: Slider;
  @Input() min: number;
  @Input() max: number;
  @Output() valuechanged: EventEmitter<Slider> = new EventEmitter();
  subs = new SubSink();
  rgbColor: string;
  cssColor: string;
  values = [];

  constructor(private configurationService: ConfigurationService) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c.rgb;
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  ngOnInit() {
    if (this.min != null && this.max != null) {
      for (var i = this.min; i <= this.max; i++) {
        this.values.push(i);
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  doSomething(v: number) {
    this.data.value = v;
    this.valuechanged.emit(this.data);
  }
}
